import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Search: BleskIcon = forwardRef(function Search(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        d="M19.1825 7.57547C21.2832 9.6761 21.2832 13.0819 19.1825 15.1825C17.0819 17.2832 13.6761 17.2832 11.5755 15.1825C9.47484 13.0819 9.47484 9.67611 11.5755 7.57547C13.6761 5.47484 17.0819 5.47484 19.1825 7.57547"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0002 18L19.1802 15.18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 7H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12H6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 17H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
